module.exports = __webpack_public_path__ + "static/media/是否參加過政府防災宣導、教育、演習 VS 是否知道住家附近政府公告的避難地點.7652643f.png";